import React, { useEffect } from 'react';
import { StyledYotpoReviews } from './YotpoReviews.styled';
import {getYotpoSlug} from '~/utils/yotpo-slugs';

export const YotpoReviews: React.FC<YotpoReviewsProps> = ({
  sku,
  slug,
  productName,
  price,
  imageUrl,
}) => {
  const curUrl = typeof window !== 'undefined' ? window.location.href : '';

  useEffect(() => {
    const scriptTag = document.createElement('script');
    scriptTag.src = `https://staticw2.yotpo.com/${process.env.GATSBY_YOTPO_APP_KEY}/widget.js`;
    document.head.appendChild(scriptTag);
  }, []);

  return (
    <StyledYotpoReviews>
      <h3>Real reviews</h3>
      <div className="yotpo bottomLine" data-yotpo-product-id={sku}></div>
      <div
        className="yotpo yotpo-main-widget"
        data-appkey={process.env.GATSBY_YOTPO_APP_KEY}
        // data-product-id={variant?.sku}
        data-product-id={getYotpoSlug(slug)}
        data-price={price}
        data-currency="USD"
        data-name={productName}
        data-url={curUrl}
        data-image-url={imageUrl}
      ></div>
    </StyledYotpoReviews>
  );
};

interface YotpoReviewsProps {
  sku: string;
  slug: string;
  productName: string;
  price: string;
  imageUrl: string;
}
